module.exports = __webpack_public_path__ + "img/logo.0341f067.png";